import { generator } from '@philips-emr/tws-core/lib/client/event-listener';

const HPMSReportOnClick = generator('onClick');

export {
  HPMSReportOnClick,
};
